import { setUpModernPage } from 'js/simple_layout/set_up_modern_page';
import registerForRails from 'js/utils/registerForRails';
import CitationGeneratorIsland from 'js/citation_generator_widget/CitationGeneratorIsland';

setUpModernPage();

registerForRails({
  CitationGeneratorIsland,
});
